// websocketClient.js
let socket;
let listeners = [];

export function connectWebSocket(url = 'wss://portal.ttpadvisory.co.uk:3556') {
  if (socket && socket.readyState !== WebSocket.CLOSED) {
    console.log('[WebSocket] Already connected');
    return socket;
  }

  console.log('[WebSocket] Connecting...');
  socket = new WebSocket(url);

  socket.onopen = () => console.log('[WebSocket] Connected ✅');

  socket.onmessage = (event) => {
    console.log('[WebSocket] Message:', event.data);
    listeners.forEach((cb) => cb(event.data));
  };

  socket.onclose = () => {
    console.log('[WebSocket] Disconnected ⚠️ Retrying in 3s...');
    setTimeout(() => connectWebSocket(url), 3000);
  };

  socket.onerror = (err) => console.error('[WebSocket] Error:', err);

  return socket;
}

export function onWebSocketMessage(callback) {
  listeners.push(callback);
}

export function closeWebSocket() {
  if (socket) socket.close();
}
